import styled from 'styled-components';

export const TableColumn = styled.div`
  flex: 1;
  max-width: 0%;
  padding-right: 16px;
  line-height: 17px;
`;
